<template>
  <v-bottom-sheet v-model="sheet" class="bottom-sheet" persistent>
        <v-sheet
          class="text-center sheet-style orange"
          color="orange darken-3"
          dark
        >
          <v-btn
            class="mt-6"
            icon
            dark
            x-large
            to="/"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
          <div class="py-3">
            Powered by
          </div>
          <v-layout class="ml-6 mr-6" align-center>
            <v-img :src="dbsLogo" contain height="200px" width="200px"/>
          </v-layout>
          <div class="mt-4">
            <b>visit us: </b>
            <a target="_blank" href="https://dbsystems.com.au"
              class="white--text text-decoration-none"
            >
              <v-btn x-small text outlined>
                DBSYSTEMS
              </v-btn>
            </a>
            <p><b>ABN:</b> 96 626 727 615</p>
          </div>

        </v-sheet>
    </v-bottom-sheet>
</template>

<script>
export default {
  name: 'About',
  data: () => ({
    sheet: true,
    dbsLogo: require('@/assets/img/dbsLogoWhite.svg')
  })
}
</script>

<style scoped>
.sheet-style {
  bottom: 0;
  position: absolute;
  margin-bottom: 0px;
};
</style>
